import { create } from "zustand";
import { toast } from "react-toastify";
import { getMedicalKpi, getMedicalKpiFilterData } from "../api";

export const useMedicalKpi = create((set) => ({
  medicalKpiData: {
    headers: [],
    total_row_count: 0,
    page_number: 0,
    page_size: 0,
    view_type: "",
    is_downloadable: false,
    rows_data: [],
    others: {},
  },
  medicalKpiDataLoading: false,
  medicalKpiDataError: null,
  medicalKpiFilterData: [],
  medicalKpiFilterDataLoading: false,
  medicalKpiFilterDataError: null,
  fetchMedicalKpiData: async (params) => {
    try {
      set({ medicalKpiDataLoading: true });
      const response = await getMedicalKpi(params);
      set({ medicalKpiData: response.data });
    } catch (error) {
      set({ medicalKpiDataError: error.message });
      toast.error(error.message);
    } finally {
      set({ medicalKpiDataLoading: false });
    }
  },
  fetchMedicalKpiFilter: async (params) => {
    try {
      set({
        medicalKpiFilterDataLoading: true,
      });
      const response = await getMedicalKpiFilterData(params);
      set({ medicalKpiFilterData: response.data });
    } catch (error) {
      set({ medicalKpiFilterDataError: error.message });
      toast.error(error.message);
    } finally {
      set({ medicalKpiFilterDataLoading: false });
    }
  },
}));
